/**
 * @prettier
 */
export function emptyStringToUndefined(value?: string): string | undefined {
    if (value === '') {
        return;
    }
    return value;
}
